import { useEffect } from 'react';
import { useCheckout } from '~/features/checkout/hooks';
import { StyledClickAndCollect } from '../../styled';
import { ClickAndCollectStores } from '../../../DeliveryStepResolver/components/ClickAndCollectStores/ClickAndCollectStores';
import type { Store } from '~/lib/data-contract/salesforce';

type Props = {
    handleCloseDrawer: () => void;
    showStepDrawer: boolean;
    onClickAndCollectStoreSelectRequest: (store: Store) => boolean;
};

export const DeliveryContentClickAndCollect = ({
    handleCloseDrawer,
    showStepDrawer,
    onClickAndCollectStoreSelectRequest,
}: Props) => {
    const { carriers, currentShipmentStep, setCarrier } = useCheckout();

    useEffect(() => {
        const [carrier] = carriers.clickAndCollect;

        if (carrier) setCarrier(carrier);
    }, [currentShipmentStep]);

    return (
        <StyledClickAndCollect>
            <ClickAndCollectStores
                handleCloseDrawer={handleCloseDrawer}
                showStepDrawer={showStepDrawer}
                onClickAndCollectStoreSelectRequest={onClickAndCollectStoreSelectRequest}
            />
        </StyledClickAndCollect>
    );
};
